import endpoint from "../Constant/endpoint";
import { updateValues } from "./authAction";
import services from "../Constant/service";
import { showErrorSnackbar, showSuccessSnackbar } from "./snackbarAction";

export const questionConfigurationAdd =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.questionConfigurationAdd,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const questionConfigurationList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.questionConfigurationList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const questionConfigurationUpdate =
  (data, id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.questionBank.questionConfigurationUpdate(id),
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res?.data.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const questionConfigurationDelete =
  (id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      endpoint.questionBank.questionConfigurationDelete(id),
      "",
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const addQuestionInBank = (data, callback) => async (dispatch) => {
  services.postApiCall(
    endpoint.questionBank.addQuestionInBank,
    data,
    (res) => {
      if (res?.statusCode === services?.status_code?.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
    },
  );
};

export const updateQuestionBank =
  (data, id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      endpoint.questionBank.updateQuestionBank(id),
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res?.data.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.response?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const deleteQuestionBank =
  (id, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.deleteApiCall(
      endpoint.questionBank.deleteQuestionBank(id),
      "",
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const listQuestionInBank =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.listQuestionInBank,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
          callback(res?.data);
        } else {
          errorCallback(res);
          dispatch(
            showErrorSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const getFoldersLocations =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.getFoldersLocations,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const awsURLCreate =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.putApiCall(
      endpoint.questionBank.awsURLCreate,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.status === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data?.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const uploadTeacherHandOutPdf =
  (url, data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    let formData = new FormData();
    formData.append("file", data);
    services.postUploadPDF(
      endpoint.questionBank.uploadTeacherHandOut,
      formData,
      { pathToUpload: url },
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
          callback(res.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const addDPPAutomaticallyExam =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.createDpp,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const addDPPAutomaticallyRecordedExam =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.createDppRecorded,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const addRecordedVideoFromTeacher =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.addRecordedVideoFromTeacher,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const getDataWithOutDpp =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.getDataWithOutDpp,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const getCompleteList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.getCompleteList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          callback(res.data);
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const updateStatusLiveToRecorded =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.updateStatusLiveToRecorded,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          callback(res.data);
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const updateLectureTitle =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.updateLectureTitle,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          callback(res.data);
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const updateLectureId =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.updateLectureId,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          callback(res.data);
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };

export const assignQuestion =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.questionBank.assignQuestion,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services?.status_code?.success) {
          callback(res.data);
          dispatch(
            showSuccessSnackbar(res?.data?.msg ? res?.data?.msg : res?.msg),
          );
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const dayWiseConversionAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.dayWiseConversionAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const dailyConversionUsers =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.dailyConversionUsers,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const copyFromLiveToLive =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.liveToLiveLecture.copyFromLiveToLive,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const getPaidAdsAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.paidAds.getPaidAdsAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const getPartTypeList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.examSet.partTypeList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const updatePartType = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.patchApiCall(
    endpoint.examSet.updatePartType,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.data?.msg));
      }
    },
    (error) => {
      dispatch(updateValues("loader", false));
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
    },
  );
};
export const addQuizConfig =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.quizOfTheDay.addQuizConfig,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const getQuizConfigList =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.quizOfTheDay.getQuizConfigList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          // dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        // dispatch(
        //   showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg)
        // );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const getSourceWiseLeadAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.categoryWiseAnalysis.getSourceWiseLeadAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        errorCallback?.(error);
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getStudentLeadAnalysis = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.categoryWiseAnalysis.getStudentLeadAnalysis,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        errorCallback?.(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      errorCallback?.(error);
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getClassroomRegistrationList =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.classroomRegistration.getClassroomRegistrationList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const updateClassroomBookingDetails =
  (data, id, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      `${endpoint.classroomRegistration.updateClassroomBookingDetails}${id}`,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getClassroomPaymentList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.classroomRegistration.getClassroomPaymentList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getClassroomInstallmentList =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.classroomRegistration.getClassroomInstallmentList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const pushNotificationAnalysis =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaign.pushNotificationAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const pushNotificationAnalysisUserDetails =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaign.pushNotificationAnalysisUserDetails,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const quizAvailableQuestionList =
  (data, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.quizOfTheDay.quizAvailableQuestionList,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const uploadResouceIndexJson = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postUploadMedia(
    endpoint.seo.uploadResouceIndexMedia,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        callback(res.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const getOriginalSourceAnalysis =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.paidAds.getOriginalSourceAnalysis,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res?.data);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };

export const addExamPartInExam =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.examSet.addExamPartInExam,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const getExamAnalyticData =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.user.getExamAnalyticData,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.msg));
          callback(res);
        } else {
          errorCallback?.(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback?.(error);
      },
    );
  };
export const addUploadFestivalBanner = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.festiveBanner.addUploadFestivalBanner,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getFestivalBannerList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.festiveBanner.getFestivalBannerList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const getWhatsAppTemplateList = (data, callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.whatsappTemplateStatus.getWhatsAppTemplateList,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services.status_code.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
        callback([]);
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};

export const updateWhatsAppTemplateList =
  (data, id, callback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.patchApiCall(
      `${endpoint.whatsappTemplateStatus.updateWhatsAppTemplateList}${id}`,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.data?.statusCode === services.status_code.success) {
          dispatch(showSuccessSnackbar(res?.data?.msg));
          callback(res?.data);
        } else {
          dispatch(showErrorSnackbar(res?.data?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
      },
    );
  };
export const getGoogleLogin = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    endpoint.auth.getGoogleLogin,
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services.status_code.success) {
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
      );
      dispatch(updateValues("loader", false));
    },
  );
};
export const cloneCampaign =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaign.cloneCampaign,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
export const addCloneEmailCampaign =
  (data, callback, errorCallback) => async (dispatch) => {
    dispatch(updateValues("loader", true));
    services.postApiCall(
      endpoint.campaign.addCloneEmailCampaign,
      data,
      (res) => {
        dispatch(updateValues("loader", false));
        if (res?.statusCode === services.status_code.success) {
          callback(res);
        } else {
          errorCallback(res);
          dispatch(showErrorSnackbar(res?.msg));
        }
      },
      (error) => {
        dispatch(
          showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
        );
        dispatch(updateValues("loader", false));
        errorCallback(error);
      },
    );
  };
